import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AboutUs from '../components/AboutUs';
import SEO from '../components/SEO';

function AboutPage({ onHomeClick, onConnectClick, onAboutClick, onContactClick, onCourseSelect, onEnrollClick, activePage, selectedCourse, setIsMobileMenuOpen }) {
  const [isMobileMenuOpen, setLocalMobileMenuOpen] = useState(false);
  const pageTopRef = useRef(null);

  // Force scroll to top on mount
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  // Handle mobile menu state
  const handleMobileMenuToggle = (isOpen) => {
    setLocalMobileMenuOpen(isOpen);
    if (setIsMobileMenuOpen) setIsMobileMenuOpen(isOpen);
  };

  // Control call button and Tawk chat visibility based on mobile menu state
  useEffect(() => {
    const callButton = document.getElementById('call-button');
    const tawkChatBox = document.getElementById('tawkchat-minified-box');
    const tawkContainer = document.getElementById('tawkchat-container');

    if (isMobileMenuOpen) {
      if (callButton) callButton.style.display = 'none';
      if (tawkChatBox) tawkChatBox.style.display = 'none';
      if (tawkContainer) tawkContainer.style.display = 'none';
    } else {
      if (callButton) callButton.style.display = 'flex';
      if (tawkChatBox) tawkChatBox.style.display = 'block';
      if (tawkContainer) tawkContainer.style.display = 'block';
    }
  }, [isMobileMenuOpen]);



  return (
    <div ref={pageTopRef}>
      <SEO title="About Oranium Tech | IT Training Institute in Chennai" description="Learn about Oranium Tech, a software training institute offering expert-led IT courses and practical learning. Explore our training programs today." />
      <Helmet>
        <title></title>
        <meta name="description" content="Learn about Oranium Tech, a software training institute offering expert-led IT courses and practical learning. Explore our training programs today." />
      </Helmet>
      <Header
        onCourseSelect={onCourseSelect}
        onEnrollClick={onEnrollClick}
        activePage={activePage}
        onHomeClick={onHomeClick}
        onAboutClick={onAboutClick}
        onContactClick={onContactClick}
        selectedCourse={selectedCourse}
        onMobileMenuToggle={handleMobileMenuToggle}
      />
      <AboutUs
        onHomeClick={onHomeClick}
        onConnectClick={onConnectClick}
        onCourseSelect={onCourseSelect}
      />
      <Footer
        onHomeClick={onHomeClick}
        onAboutClick={onAboutClick}
        onContactClick={onContactClick}
        onCourseSelect={onCourseSelect}
      />
    </div>
  );
}

export default AboutPage;